import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Sparkles, Loader2, X } from 'lucide-react';

const AISuggestReplies = ({ kind, text, author, rating, channel, history = [], onPick, compact = false }) => {
  const { API, getAuthHeaders } = useAuth();
  const [loading, setLoading] = useState(false);
  const [replies, setReplies] = useState(null);

  const fetchSuggestions = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${API}/ai-social/suggest-reply`, { kind, text, author, rating, channel, history }, getAuthHeaders());
      setReplies(res.data.replies);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Errore nel generare le proposte');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-2" data-testid="ai-suggest-replies">
      {!replies && (
        <Button type="button" variant="outline" size={compact ? 'sm' : 'default'} className="border-primary/40 text-primary hover:bg-primary/5" onClick={fetchSuggestions} disabled={loading || !text} data-testid="ai-suggest-btn">
          {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Sparkles className="w-4 h-4 mr-2" />} Suggerisci risposta AI
        </Button>
      )}
      {replies && (
        <div className="rounded-lg border bg-muted/30 p-2 space-y-1.5">
          <div className="flex items-center justify-between px-1">
            <span className="text-xs font-medium flex items-center gap-1"><Sparkles className="w-3 h-3 text-primary" /> Proposte AI — clicca per usare</span>
            <div className="flex gap-1">
              <Button type="button" variant="ghost" size="sm" className="h-6 text-xs px-2" onClick={fetchSuggestions} disabled={loading} data-testid="ai-suggest-refresh-btn">{loading ? <Loader2 className="w-3 h-3 animate-spin" /> : 'Altre'}</Button>
              <Button type="button" variant="ghost" size="sm" className="h-6 w-6 p-0" onClick={() => setReplies(null)} data-testid="ai-suggest-close-btn"><X className="w-3 h-3" /></Button>
            </div>
          </div>
          {replies.map((r, i) => (
            <button key={i} type="button" onClick={() => onPick(r.text)} className="w-full text-left rounded-md border bg-background p-2 hover:border-primary transition-colors" data-testid={`ai-suggest-option-${i}`}>
              <span className="text-[10px] uppercase tracking-wide text-primary font-semibold">{r.label}</span>
              <p className="text-sm mt-0.5 whitespace-pre-wrap">{r.text}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AISuggestReplies;
